module.exports = __webpack_public_path__ + "static/liofilizat_sloik@0,5x-a1a2fa7e3886144caa672051c7012d7b.png";